module.exports = __webpack_public_path__ + "img/sign-in-title-bg.619dbd8e.png";